import { Result } from "antd";

const EmptyData = () => {
    return (
        <Result
            status="404"
            title="No data"
        />
    )
}

export default EmptyData;